import React, { ReactNode } from 'react';
import { Link } from 'react-router';

interface Props {
    title?: string;
    children: ReactNode;
    link?: string;
    className?: string;
}

function Postit(props: Props) {
    if (props.link) {
        return (
            <Link className={'no-hover'} to={props.link}>
                {renderPostIt()}
            </Link>
        );
    } else {
        return renderPostIt();
    }

    function renderPostIt() {
        return (
            <div className={`postit ${props.className || ''}`}>
                {props.title ? (
                    <h2 className={'headline1'}>{props.title}</h2>
                ) : (
                    ''
                )}
                {props.children}
            </div>
        );
    }
}

export default Postit;
